module.exports = __webpack_public_path__ + "static/media/Marching_Band_Electronics_FA_2022_2023.aff7056e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/Marching_Band_Electronics_FA_2022_2023.pdf
// module id = 190
// module chunks = 0